// Form events for Clarity and GA4 only (sent from the browser; nothing goes to Cyannect's API).
// Usage: const fa = useFormAnalytics("demo_request"); <form {...fa.formProps}>
import { useEffect, useRef } from "react";
import api from "@/lib/api";
import { trackEvent, utmParams } from "@/lib/analytics";
import { clarityEvent } from "@/lib/clarity";

const NAMES = {
  demo_request: { clarity: { form_opened: "contact_form_opened", form_started: "contact_form_started", form_submitted: "contact_form_submitted", form_abandoned: "contact_form_abandoned" },
    ga: { form_started: "contact_form_start", form_abandoned: "contact_form_abandon" } },
  merchant_signup: { clarity: { form_started: "merchant_signup_started" }, ga: {} },
};
let cfgPromise;
const config = () => (cfgPromise ||= api.get("/form-analytics/config").then((r) => r.data).catch(() => ({})));
export const formConfig = config;

export function useFormAnalytics(formId, { enabled = true } = {}) {
  const st = useRef({ started: false, submitted: false, leftOnce: false, cfg: {} });

  const emit = (event) => {
    if (!enabled) return;
    const n = NAMES[formId] || { clarity: {}, ga: {} };
    if (n.clarity[event]) clarityEvent(n.clarity[event]);
    if (n.ga[event] && st.current.cfg.ga4_form_events) trackEvent(n.ga[event], { form_id: formId, ...utmParams() });
  };

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    config().then((c) => { if (alive) { st.current.cfg = c || {}; emit("form_opened"); } });
    const leave = () => {
      const s = st.current;
      if (s.started && !s.submitted && !s.leftOnce) { s.leftOnce = true; emit("form_abandoned"); }
    };
    window.addEventListener("pagehide", leave);
    return () => { alive = false; window.removeEventListener("pagehide", leave); leave(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formId, enabled]);

  const formProps = {
    onInputCapture: () => { const s = st.current; if (!s.started) { s.started = true; emit("form_started"); } },
    "data-clarity-mask": "true",
  };
  return { formProps, submitted: () => { st.current.submitted = true; emit("form_submitted"); } };
}
